var map = {
	"./ar.json": 26726,
	"./de.json": 39929,
	"./el.json": 34690,
	"./en-GB.json": 43171,
	"./en.json": 20790,
	"./es.json": 18563,
	"./fr.json": 844,
	"./he.json": 8818,
	"./it.json": 20504,
	"./ja.json": 8566,
	"./mt.json": 8871,
	"./nl.json": 13055,
	"./pl.json": 75143,
	"./pt.json": 69898,
	"./ru.json": 69672,
	"./sv.json": 93244,
	"./th.json": 42009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8973;